import { tlLogError } from "../Helpers/ConsoleLoggerHelper";
import { BaseTLComponent, AxiosResponse, Watch, EnumsService, EnumsFilter } from "./CoreBase";

export default abstract class BaseTLDetailComponent extends BaseTLComponent {
	private newDescription: string = '';
	private detailDescription: string = '';

	//VaPTODO - proverit, zda isSuccessfully je jeste potreba nebo ne?
	//        - na prvni dobou je to pozustatek stare podoby formulare
	protected isSuccessfully: boolean = false;
	//VaPTODO - proverit, zda onlyShow je jeste potreba nebo ne?
	//        - na prvni dobou je to pozustatek stare podoby formulare
	protected onlyShow: boolean = false;
	//šířky sloupců
	protected labelWidth: string = "3";
	protected inputWidth: string = "8";
	protected buttonWidthWithInput: string = "2";
	protected styleFormDetail: boolean = false;
	protected styleFormNew: boolean = false;
	protected styleFormDelete: boolean = false;
	protected mainDescription: string = '';
	protected returnRoute: string = "returnRoute";
	protected formIsInEditMode: boolean = false;
	protected mainDataChanged: boolean = false; //zmena dat
	protected mainDataChangedSub: boolean = false;//zmena dat pod seznamu

	protected alertModalIdToDelete: string = 'alertModalIdToDelete';
	protected alertModalIdToCancelEditing: string = 'alertModalIdToCancelEditing';
	protected formData: any;
	protected isWarningBeforeDelete: boolean = false; //varovani pred smazaním (kdyz napriklad existuji nejake vazby)
	protected formDataBeforeEdit: any;
	protected allowEdit: boolean = false; // kdyz chceme povolit jit na detail napr. vlatnikovi (nema pravo canRead)
	
	protected allowChangeUrlAfterCreate: boolean = true;
	protected isLoginPage: boolean = false;
	protected get showSaveButton(): boolean {
		return (this.canUpdate || this.allowEdit ) && this.formIsInEditMode;
	}

	protected get disabledSaveButton(): boolean {
		this.mainDataChanged = this.dataWasChanged() && this.formDataBeforeEdit != undefined;
		return !this.mainDataChanged;
	}

	protected get showCancelButton(): boolean {
		return this.formIsInEditMode;
	}

	protected get showBackButton(): boolean {
		return !this.formIsInEditMode;
	}

	protected get showDeleteButton(): boolean {
		return this.canDelete && !this.formIsInEditMode;
	}

	protected get showEditButton(): boolean {
		return !this.formIsInEditMode && this.styleFormDetail && (this.canUpdate || this.allowEdit);
	}

	protected get offsetButtons(): number {
		return !this.styleFormDetail ? 2 : 3;
	}

	protected get objectId(): number {
		//VaP - po create aby sel udelat update
		if (this.formData.id && this.formData.id > 0) {
			return this.formData.id;
		}
		return this.objectIdFromQuery;
		//if (this.objectIdFromQuery > 0) {
		//	return this.objectIdFromQuery;
		//}
		//else {
		//	//TODO tohle je jen docasne
		//	return this.objectIdFromParam;
		//}
	}

	private enumsServiceTable: EnumsService = new EnumsService();
	//pro modalni tabulky
	protected async loadFiltersEnumListModal(pattern: any[], filters: any) {
		for (var ma = 0; ma < pattern.length; ma++) {
			var identifEnum = pattern[ma].key;
			let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, identifEnum, false);
			var result: any[] = [];
			await this.enumsServiceTable.getAllByFilter(enumsFilter).then((response) => {
				for (var i = 0; i < response.data.length; i++) {
					result.push({
						key: pattern[ma].key + i, value: response.data[i].identifier, label: response.data[i].name, selected: pattern[ma].selected,
						type: pattern[ma].type, group: pattern[ma].group, groupId: pattern[ma].groupId, groupName: pattern[ma].groupName, headName: pattern[ma].headName, isNegative: pattern[ma].isNegative
					});
				}
			});

			for (var i = 0; i < result.length; i++) {
				if (filters.filter((c: any) => c.key == result[i].key).length == 0)
					filters.push(result[i]);
			}
		}
	}

	protected mounted(fetchOnStart: boolean = true) {
		
		if (fetchOnStart) {
			this.fetchData();
		}
	};

	protected deleteClick(): void {
		this.setFormStyleToDelete();
		this.doAction();
	}


	protected showAllertToDeleteClick() {
		//VaP - pokud bude nastaveno, ze se nema ptat, tak rovnou smazeme, ale v ostatnich pripadech dotaz zobrazime, je to bezpecnejsi varianta
		if (this.$store.state.askBeforeDelete === false && this.isWarningBeforeDelete  == false) {
			this.deleteClick();
		}
		else {
			this.showAlertModalById(this.alertModalIdToDelete);
		}
	}

	protected showAllertToCancelEditingClick() {
		//VaP - pokud bude nastaveno, ze se ma ptat a zmenila se data, tak zobrazime dotaz
		if (this.$store.state.askBeforeCancelEditing === true && this.dataWasChanged()) {
			this.showAlertModalById(this.alertModalIdToCancelEditing);
		}
		else {
			this.goBackNotChange();
		}
	}

	protected showAllertToCancelEditingWithSubClick() {
		//VaP - pokud bude nastaveno, ze se ma ptat a zmenila se data, tak zobrazime dotaz
		if (this.$store.state.askBeforeCancelEditing === true && (this.dataWasChanged() || this.formIsInEditModeSubChange)) {
			this.showAlertModalById(this.alertModalIdToCancelEditing);
		}
		else {
			this.goBackNotChange();
		}
	}

	protected goBackNotChange(): void {
		this.formIsInEditMode = false;
		if (!this.styleFormNew) {
			this.fetchData();
		}
		else {
			this.goBack();
		}
	}

	protected fetchData() {
		super.setOwner();
		if (!this.isLoginPage) {
			if (super.hasRightOrIsOwnerPage()) {
				// pri vytvareni noveho prvku nemame co dotahovat z RESTovky
				if (!this.styleFormNew) {
					this.isBusy = true;
					this.fetchDataFromServer().then((response) => {
						this.isBusy = false;
						this.processResponse(response);
					}).catch((error) => {
						if (!super.isTokenExpired(error)) {
							this.showErrorMessageFromResponse(error);
						}
						else if (error.status == 404) {
							this.showErrorMessageFromResponse(error);
							//	this.showErrorMessage(this.$t('global.messageErrorNotFound').toString());
						}
						this.isBusy = false;
					});
				}
			}
			else {
				this.showAlertModalWithTitleAndContent(this.$t('global.error').toString(), this.$t('global.errorRight').toString());// VaPTODO - bohuzel error message se zobrazi az po te, co je komponenta mounted, do te doby se neozbrazi, coz je vlastne spravne
				//         - stejne tak, pokud se vyskytne nekolik showmessage, tak se uzivateli zobrazi pouze ta posledni, jelikoz se neceka na odznaceni te prvni zpravy
				//         - z toho duvodu musime namyslet a udelat variantu, ze se chybove zpravy budou ukladat do nejake kolekce chyb a jakmile dojde na mounted komponenty, tak se dane zpravy postupne zobrazi
			}
		}
	}

	protected fetchAfterRefresh() {
		this.fetchDataFromServer().then((response) => {
			this.processResponse(response);
		}).catch((error) => {
			if (!super.isTokenExpired(error)) {
				this.showErrorMessageFromResponse(error);
			}
			else if (error.status == 404) {
				this.showErrorMessageFromResponse(error);
			}
		});
	}

	protected timerRefresh() {
		this.fetchRefreshData();
	}

	//jednodussi refresh verze
	protected fetchRefreshData() {
		super.setOwner();

		if (super.hasRightOrIsOwnerPage()) {	
			if (this.objectId > 0) {
				this.fetchRefreshDataFromServer().then((response) => {
					this.formData = this.refreshItems(this.formData, response.data);
				}).catch((error) => {
					tlLogError('refreshData', error);
				});
			}
		}
		else {
			tlLogError('refreshData', 'nejsou prava');			
		}
	}

	protected callActionAndShowErrorInfoMessage(action: Promise<AxiosResponse<any>>, successMessage: string, fetchData: boolean = false) {
		this.isBusy = true;
		action.then(() => {
			this.isSuccessfully = true;
			this.showAlertModalWithInfoMessage(successMessage);
			if (fetchData) {
				this.fetchData();
			}
			this.isBusy = false;
		}).catch((error) => {
			this.showErrorMessageFromResponse(error);
			this.isBusy = false;
		});
	}

	protected setFormStyleToDelete(): void {
		this.styleFormDelete = true;
		this.styleFormDetail = false;
		this.styleFormNew = false;
	}

	protected initializeRights(createRightString: string | undefined, deleteRightString: string | undefined, readRightString: string | undefined, updateRightString: string | undefined) {
		//VaP - nejdrive nastavime prava
		super.initializeRights(createRightString, deleteRightString, readRightString, updateRightString);
		//VaP - a pak podle prav a params type nastavime formStyle
		this.setFormStyle();
	}

	protected setMainDescription(newDescription: string, detailDescription: string) {
		this.newDescription = newDescription;
		this.detailDescription = detailDescription;
		this.setDescriptionByFormState();
	}

	private setDescriptionByFormState() {
		if (this.styleFormNew === true) {
			this.mainDescription = this.newDescription;
		}
		else {
			this.mainDescription = this.detailDescription;
		}
	}

	protected goBack(): void {
		this.$router.push({ name: this.returnRoute });
	}

	protected goToEdit(): void {
		this.formIsInEditMode = !this.formIsInEditMode;
	}

	public afterCreateChangeUrl(id: string) {
		if (this.allowChangeUrlAfterCreate) {
			var namePage = String(this.$router.currentRoute.name);
			var newQuery = {};
			//@ts-ignore
			newQuery['id'] = id;
			this.$store.commit("mainDataChanged", false);
			this.$store.commit("formIsInEditMode", false);
			this.$router.replace({ name: namePage, query: newQuery });
		}
	}

	protected doCRUDActionWithInfoMessage(newDescription: string, updateDescription: string, deleteDescription: string) {
		this.isBusy = true;
		this.callAction().then((result) => {
			this.isSuccessfully = true;
			if (this.styleFormNew) {
				this.afterCreate(result);
				this.afterCreateChangeUrl(result.data.id);
				this.formIsInEditMode = false;
			}
			if (this.styleFormDetail) {
				this.afterUpdate(result);
				this.$store.commit("mainDataChanged", false);
			}
			// VaPTODO - pro delete potrebujeme uzivatele presmerovat zpatky na seznam, ale pri soucasnem voladni dialogu s tim nejde pockat, az ho uzivatel potvrdi, takze nema cenu ho vubec zobrazovat
			//         - mozna varianta reseni je zde https://redmine.trustlab.cz/issues/429 v bode 17
			if (this.styleFormDelete) {
				this.afterDelete(result);
				this.goBack()
			} else {
				this.goToEdit();
				this.showSuccessMessage(newDescription, updateDescription, deleteDescription);
			}
			if (this.styleFormNew) {
				this.styleFormNew = false;
				this.styleFormDetail = true;
				this.formIsInEditMode = false;
			}
			this.isBusy = false;
			this.setDescriptionByFormState();
		}).catch((error) => {
			this.isBusy = false;
			if (error.status == undefined) {
				super.showAlertModalWithErrorMessageList(this.$t('global.messageErrorTimeout'));
			}
			else {
				this.showErrorMessageFromResponse(error);
			}
			
		});
	}

	protected showErrorMessageFromResponse(error: any): void {
		this.isSuccessfully = false;
		let errorMessage = this.$t('global.messageErrorUnexpected');


		if (error.status == undefined) {
			errorMessage = this.$t('global.messageErrorTimeout');
		}
		else if (error.status == 404) {
			errorMessage = this.$t('global.messageErrorNotFound');
		}
		else if (error.data.errors == undefined) {
			errorMessage = error.data;
		}
		if (error && error.data && error.data.errors && error.data.errors.length > 0) {
			errorMessage = '';
			for (var i = 0; i < error.data.errors.length; i++) {
				errorMessage += i > 0 ? '<br>' : '';
				errorMessage += error.data.errors[i];
			}
		}
		
		super.showAlertModalWithErrorMessageList(errorMessage);
	}


    @Watch('formIsInEditMode')
	formIsInEditModeChange(value: boolean, oldValue: boolean) {
		if (value != oldValue) {

			if (value == true) {
				this.formDataBeforeEdit = null;
				this.formDataBeforeEdit = JSON.parse(JSON.stringify(this.formData));
			}
			this.$store.commit("formIsInEditMode", this.formIsInEditMode);
        }
	}


	@Watch('mainDataChanged')
	mainDataChangedChange(value: boolean, oldValue: boolean) {
		if (value != oldValue) {
			this.$store.commit("mainDataChanged", this.mainDataChanged);
		}
	}

	@Watch('mainDataChangedSub')
	formIsInEditModeSubChange(value: boolean, oldValue: boolean) {
		if (value != oldValue) {
			this.$store.commit("mainDataChangedSub", this.mainDataChangedSub);
		}
	}

	protected dataWasChanged(): boolean {	
		var formDataBefore = JSON.stringify(this.formData);
		var formDataNew = JSON.stringify(this.formDataBeforeEdit);
		return formDataBefore != formDataNew;
	}

	private callAction(): Promise<AxiosResponse<any>> {
		if (this.styleFormDelete) {
			return this.deleteObject();
		}
		else if (this.styleFormDetail) {
			return this.updateObject();
		}
		else {
			return this.createObject();
		}
	}

	private showSuccessMessage(newDescription: string, updateDescription: string, deleteDescription: string): void {
		if (this.$store.state.showInfoMessagesOnDetail === true) {
			if (this.styleFormDelete) {
				this.showAlertModalWithInfoMessage(deleteDescription);
			}
			else if (this.styleFormDetail) {
				this.showAlertModalWithInfoMessage(updateDescription);
			}
			else {
				this.showAlertModalWithInfoMessage(newDescription);
			}
		}
	}

	private setFormStyle() {	
		//let typeCreate: string = this.$router.currentRoute.query.type == undefined? '': this.$router.currentRoute.query.type.toString();
		var isNew = false;
		if (this.$router.currentRoute.query.id == undefined || (this.$router.currentRoute.query.id == '0' )) {
			isNew = true;
		}

		this.styleFormDetail = !isNew;
		this.styleFormNew = isNew;
		
		this.styleFormDetail = !this.styleFormNew && !this.styleFormDelete;
		this.formIsInEditMode = this.styleFormNew;
		this.onlyShow = this.styleFormDelete || this.formIsInEditMode;
	}

	protected afterDelete(response: AxiosResponse<any>): void {
	}

	protected afterUpdate(response: AxiosResponse<any>): void {
	}

	protected afterCreate(response: AxiosResponse<any>): void {
	}

	protected updateObject(): Promise<AxiosResponse<any>> {
		return super.NoCall();
	}

	protected createObject(): Promise<AxiosResponse<any>> {
		return super.NoCall();
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		return super.NoCall();
	}

	//VaPTODO - predelat na abstract, az to budou mit vsechny base implementovane
	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall();
	}


	//auto refresh
	protected abstract fetchRefreshDataFromServer(): Promise<AxiosResponse<any>>;

	protected abstract refreshItems(items: any, refreshData: any): any;

	protected getName(): string {
		return this.$t(this.mainDescription).toString();
	}

	protected processResponse(response: AxiosResponse<any>): void {
	}

	protected doAction(): void {
	}


	//VaPTODO - po predelani vsech formularu zrusit tuto metodu
	protected created() {
	
	}



	//VaPTODO - po predelani vsech formularu zrusit tuto metodu
	protected setMainDescriptionOld(newDescription: string, detailDescription: string, updateDescription: string, deleteDescription: string) {
		if (this.styleFormDetail === true) {
			this.mainDescription = detailDescription;
		}
		else if (this.styleFormDelete === true) {
			this.mainDescription = deleteDescription;
		}
		else {
			this.mainDescription = newDescription;
		}
	}

	protected changeTranslate(items: any): Array<any> {
		var itemsList = items as Array<any>;
		for (var i = 0; i < itemsList.length; i++) {
			if (itemsList[i].trans != undefined) {
				itemsList[i].label = this.$t(itemsList[i].trans);
			}
		}
		return itemsList;
	}


	//@ts-ignore
	@Watch('$store.state.currentLanguage')
	changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
		this.fetchData();
	}

}
